import React, {useContext, useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import { Typography, Chip } from "@material-tailwind/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faUser, faSchool, faUserTie, faCheck } from '@fortawesome/free-solid-svg-icons';
import {CategoriesChipColors, ProjectInfo} from '../../../models/ProjectForm';
import projectFormService from '../../../services/forms/projectForm.service';
import {faClone} from "@fortawesome/free-regular-svg-icons";
import {colors} from "@material-tailwind/react/types/generic";
import AppTitleContext from "../../../context/AppTitleContext";
import './ProjectDetails.css';

const ProjectDetails = () => {
    const id = useParams().id || '0';
    const [project, setProject] = useState<ProjectInfo>({} as ProjectInfo);
    const { updateAppTitle } = useContext(AppTitleContext);

    async function getProject() {
        let response = await projectFormService.getProject(id);
        setProject(response?.project);
    }

    const getChipColor = (value: string): colors => {
        return CategoriesChipColors[value] || 'black';
    }

    useEffect(() => {
        getProject();
    }, [id]);

    useEffect(() => {
        updateAppTitle([{title: 'Proyectos', href: '/admin/forms/projects'}, {title: project?.projectName || '404'}]);
    }, [project]);

    return (
        <div className="flex">
            <div className='project'>
                <div className="project-details">
                    {
                        project ? (
                            <>
                                <div className="project-info">
                                    <Typography placeholder='' variant="h2" color="black">{project?.projectName}</Typography>
                                    <div className="flex gap-2">
                                        <Chip value={project?.category} size="sm" color={getChipColor(project?.category)} />
                                        <Chip value={project?.subject} size="sm" color="amber" />
                                    </div>
                                </div>
                                <Typography placeholder='' className='mt-5 mb-2' variant="h3" color="black">Integrantes</Typography>
                                <div className="members">
                                    {project?.members?.map((member, index) => (
                                        <div key={index} className="member">
                                            {member.gender === 'Masculino' ? (
                                                <p><FontAwesomeIcon icon={faUser} color='blue' /> {member.name}</p>
                                            ) : member.gender === 'Femenino' ? (
                                                <p><FontAwesomeIcon icon={faUser} color='pink' /> {member.name}</p>
                                            ) : (
                                                <p><FontAwesomeIcon icon={faUser} color='purple' /> {member.name}</p>
                                            )}
                                            <div className="flex gap-5 items-center">
                                                <p><FontAwesomeIcon icon={faSchool} color='#feb310' /> {member.eduProgram}</p>
                                                <div className='flex items-center'>
                                                    <p><FontAwesomeIcon icon={faEnvelope} color='#feb310' /> {member.email}</p>
                                                    <FontAwesomeIcon
                                                        className='info-email-clone'
                                                        onClick={() => { navigator.clipboard.writeText(member.email) }}
                                                        icon={faClone}
                                                        color='gray'/>
                                                </div>
                                            </div>
                                            <div className="horizontal-line"></div>
                                        </div>
                                    ))}
                                </div>
                                <Typography placeholder='' className='mt-5 mb-2' variant="h3" color="black">Asesores</Typography>
                                <div className="advisors">
                                    {project?.advisors?.map((advisor, index) => (
                                        <div key={index}>
                                            <div className="flex justify-between">
                                                <span className='flex gap-2 items-center'>
                                                    <p><FontAwesomeIcon icon={faUserTie} color='black' /> {advisor.name}</p>
                                                    <div className='flex items-center'>
                                                        <p><FontAwesomeIcon icon={faEnvelope} color='#feb310' /> {advisor.email}</p>
                                                        <FontAwesomeIcon
                                                            className='info-email-clone'
                                                            onClick={() => { navigator.clipboard.writeText(advisor.email) }}
                                                            icon={faClone}
                                                            color='gray'/>
                                                    </div>
                                                </span>

                                                {advisor.certificate != null && (
                                                    <span className='self-center'>
                                                        <span className='flex items-center gap-1 bg-green-800 p-1 rounded'>
                                                            <FontAwesomeIcon icon={faCheck} color='white' size='xs' />
                                                        </span>
                                                    </span>
                                                )}
                                            </div>
                                            <div className="horizontal-line"></div>
                                        </div>
                                    ))}
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="project-info flex justify-center">
                                    <Typography placeholder='' variant="h2"
                                                color="black">Proyecto no disponible</Typography>
                                </div>
                            </>
                            )
                            }
                            </div>
                        </div>
                        </div>
                        );
                    };

export default ProjectDetails;